import _HcLocalizer from './HcLocalizer';
import _HcLocalizerVuePlugin from './vue/HcLocalizerVuePlugin';

export default _HcLocalizer;

export class HcLocalizer extends _HcLocalizer {}
export class HcLocalizerVuePlugin extends _HcLocalizerVuePlugin {}
